import electron from "../electron";
import { isMacOS } from "./ua-utils";

enum SelectionMode {
    SingleClick = "singleClick",
    DoubleClick = "doubleClick"
}

function getSelectionMode(): SelectionMode {
    // Electron app on mac os should use double click to select
    if (electron && isMacOS()) {
        return SelectionMode.DoubleClick;
    }

    return SelectionMode.SingleClick;
}

export {
    getSelectionMode,
    SelectionMode
};
